export const productData = [
  {
    productImage: 'https://iccdn.in/img/redmi-note-11-blue.png',
    merchantLogo: 'https://iccdn.in/merchant/logos/zebrs-logo.png',
    productName: 'Redmi 11',
    tenure: '*on 3,6,9,12 mo EMIs',
    isNoCost: true,
  },
  {
    productImage: 'https://iccdn.in/img/xiaomi-11t-pro-5g-white-8gb.png',
    merchantLogo: 'https://iccdn.in/merchant/logos/zebrs-logo.png',
    productName: 'Redmi 11T pro',
    tenure: '*on 3,6,9,12 mo EMIs',
    isNoCost: true,
  },
];



// WEBPACK FOOTER //
// ./routes/campaign-activation/componentsVMerchant/productSection/data.js